import { render } from "./VipUpgradeDiffBanner.vue?vue&type=template&id=d6b0d596&scoped=true"
import script from "./VipUpgradeDiffBanner.vue?vue&type=script&lang=js"
export * from "./VipUpgradeDiffBanner.vue?vue&type=script&lang=js"

import "./VipUpgradeDiffBanner.vue?vue&type=style&index=0&id=d6b0d596&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b0d596"]])

export default __exports__